import {authorize, authorizeSignup} from '../../lib/api/v1/oauth/authorization';
import {callback} from '../../lib/api/v1/oauth/callback';
import {signupCallback} from '../../lib/api/v1/oauth/signupCallback';
import {ApiResponse, ApiResponseError} from '../../lib/api/v1/types';

interface OAuthAuthorizationResponse {
  providerAuthorizationUrl: string;
}

interface OAuthCallBackResponse {
  publicProfileUrl: string;
  profilePictureUrl: string;
}

export class OAuthService {
  static async authorize(provider: string): Promise<ApiResponse<OAuthAuthorizationResponse>> {
    try {
      const response = await authorize(provider);
      const body = await response.json();

      if (response.ok) {
        const serializedBody = {
          providerAuthorizationUrl: body.provider_authorization_url,
        };

        return {
          ok: true,
          data: serializedBody,
          error: undefined,
        };
      }

      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: unknown) {
      console.error(error);
      throw error;
    }
  }

  static async authorizeSignup(provider: string): Promise<ApiResponse<OAuthAuthorizationResponse>> {
    try {
      const response = await authorizeSignup(provider);
      const body = await response.json();

      if (response.ok) {
        const serializedBody = {
          providerAuthorizationUrl: body.provider_authorization_url,
        };

        return {
          ok: true,
          data: serializedBody,
          error: undefined,
        };
      }

      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: unknown) {
      console.error(error);
      throw error;
    }
  }

  static async callback(
    provider: string,
    authorizationCode: string,
    state: string
  ): Promise<ApiResponse<OAuthCallBackResponse>> {
    try {
      const response = await callback(provider, authorizationCode, state);
      const body = await response.json();
      const serializedBody = {
        publicProfileUrl: body.public_profile_url,
        profilePictureUrl: body.profile_picture_url,
      };

      if (response.ok) {
        return {
          ok: true,
          data: serializedBody,
          error: undefined,
        };
      }

      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: unknown) {
      console.error(error);
      throw error;
    }
  }

  static async signupCallback(
    provider: string,
    authorizationCode: string,
    state: string
  ): Promise<ApiResponse<any>> {
    try {
      const response = await signupCallback(provider, authorizationCode, state);
      const body = await response.json();

      if (response.ok) {
        return {
          ok: true,
          data: body,
          error: undefined,
        };
      }

      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: unknown) {
      console.error(error);
      throw error;
    }
  }
}
